import { render, staticRenderFns } from "./answerRecordTwo.vue?vue&type=template&id=11befcc8&scoped=true"
import script from "./answerRecordTwo.vue?vue&type=script&lang=js"
export * from "./answerRecordTwo.vue?vue&type=script&lang=js"
import style0 from "./answerRecordTwo.vue?vue&type=style&index=0&id=11befcc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11befcc8",
  null
  
)

export default component.exports